module.exports = __webpack_public_path__ + "static/media/space-bg-2.472c03a1.png";